"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const Teaser_vue_1 = __importDefault(require("../Teaser.vue"));
const floating_vue_1 = require("floating-vue");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const eBeCropIcon_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/StatusTags/eBeCropIcon.vue"));
const eBeCropTag_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/StatusTags/eBeCropTag.vue"));
const Recommendation_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/Recommendation.vue"));
const RecommendationFieldComponent_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/RecommendationFieldComponent.vue"));
const RecommendationsBuildingBadge_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/RecommendationsBuildingBadge.vue"));
let AIGenItem = class AIGenItem extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.hasEnabledRecommendations = false;
        this.productSlugSelected = '';
        this.productSelected = null;
        this.eventTracker = new EventTracker_1.default();
    }
    get recommendationsStatus() {
        if (this.currentFarm.recommendations.length > 0) {
            return 'has_recommendations';
        }
        else {
            if (this.currentFarm.fields.every((f) => f.status === 'pending_retrieval')) {
                return 'pending_retrieval';
            }
            if (this.currentFarm.fields.every((f) => f.status === 'no_recommendations')) {
                return 'no_recommendations';
            }
        }
        return 'no_recommendations';
    }
    updateProductSelected(product) {
        this.productSlugSelected = product.slug;
        this.productSelected = product;
    }
    openRecommendations() {
        this.hasEnabledRecommendations = !this.hasEnabledRecommendations;
        if (this.currentFarm.recommendations.length > 0) {
            this.updateProductSelected(this.currentFarm.recommendations.sort((a, b) => b.level - a.level)[0]);
        }
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    eventTrackerRecommendationsPanel() {
        this.eventTracker.trackEvent('openRecommendationsPanel', true);
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    manageRecommendationDeployment() {
        if (this.forceDismiss) {
            this.$emit('onToggleRecommendations', false);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], AIGenItem.prototype, "isActive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], AIGenItem.prototype, "forceDismiss", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], AIGenItem.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], AIGenItem.prototype, "certification", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], AIGenItem.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], AIGenItem.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('forceDismiss')
], AIGenItem.prototype, "manageRecommendationDeployment", null);
AIGenItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Teaser: Teaser_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            Dropdown: floating_vue_1.Dropdown,
            eBeCropIcon: eBeCropIcon_vue_1.default,
            eBeCropTag: eBeCropTag_vue_1.default,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            X: lucide_vue_next_1.X,
            ChevronUp: lucide_vue_next_1.ChevronUp,
            Recommendation: Recommendation_vue_1.default,
            RecommendationFieldItem: RecommendationFieldComponent_vue_1.default,
            RecommendationsBuildingBadge: RecommendationsBuildingBadge_vue_1.default
        },
    })
], AIGenItem);
exports.default = AIGenItem;
